import React, { useState, useMemo, useCallback } from "react";
import Select from "react-select";
import { filterAndSlice } from "../util/selectUtils";

const MultiSelectField = ({ label, sublabel, options, field, required, isDisabled, placeholder, onSelectionChange }) => {
  const [inputValue, setInputValue] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);

  const slicedOptions = useMemo(
    () => filterAndSlice(options, inputValue),
    [options, inputValue]
  );

  const updateHiddenField = useCallback((values) => {
    const el = document.getElementById(field);
    if (el) {
      el.value = values.length > 0 ? JSON.stringify(values) : "";
    }
  }, [field]);

  const onChange = useCallback((opts) => {
    if (!opts || opts.length === 0) {
      setSelectedValues([]);
      updateHiddenField([]);
      onSelectionChange?.([]);
      return;
    }
    const values = opts.map((opt) => opt.value);
    setSelectedValues(opts);
    updateHiddenField(values);
    onSelectionChange?.(values);
  }, [updateHiddenField, onSelectionChange]);

  return (
    <div>
      <label className={`block text-sm font-medium text-gray-700 ${required ? "required" : ""}`}>
        {label}
      </label>
      {sublabel && <p className="text-xs text-gray-400 mb-1">{sublabel}</p>}
      <Select
        isClearable
        isMulti
        isDisabled={isDisabled}
        options={slicedOptions}
        value={selectedValues}
        onChange={onChange}
        onInputChange={(value) => setInputValue(value)}
        filterOption={() => true}
        placeholder={placeholder}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default MultiSelectField;
